import React, { useState, useEffect } from "react";
import "./HomeSeventhSection.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useCurrency } from "../../Context/CurrencyContext";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://volumaire.backendapihub.com";
const DEFAULT_IMAGE = "/images/dailyroutine2.webp";

const staticProducts = [
  {
    id: 1,
    img: "/images/7thsectionimage1.webp",
    title: "Active toning essence",
    price: 599,
    priceValue: 599,
    modelImg: "/images/7thsectionimage2.webp",
    subtitle: "Revitalizes Skin!"
  },
  {
    id: 2,
    img: "/images/7thsectionimage4.webp",
    title: "Firming anti-aging face cream",
    price: 699,
    priceValue: 699,
    modelImg: "/images/7thsectionimage3.webp",
    subtitle: "Improves Skin Hydration!"
  }
];

const HomeSeventhSection = () => {
  const { formatPrice } = useCurrency();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [index, setIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const normalizeImageUrl = (imageUrl) => {
    if (!imageUrl || imageUrl.trim() === "" || imageUrl === "null" || imageUrl === "undefined") {
      return null;
    }
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://') || imageUrl.startsWith('data:')) {
      return imageUrl;
    }
    if (imageUrl.startsWith('/')) {
      return `${BASE_URL}${imageUrl}`;
    }
    return `${BASE_URL}/${imageUrl}`;
  };

  const isValidImageUrl = (url) => {
    if (!url) return false;
    const strUrl = String(url).trim();
    return strUrl !== "" &&
      strUrl !== "null" &&
      strUrl !== "undefined" &&
      !strUrl.includes('undefined') &&
      !strUrl.includes('null');
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const apiUrl = "https://volumaire.backendapihub.com/api/complete-products/bestsellers?countryCode=US";
        const response = await fetch(apiUrl, {
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          throw new Error('Response is not JSON');
        }

        const data = await response.json();

        let productArray = [];
        if (Array.isArray(data)) productArray = data;
        else if (data?.products) productArray = data.products;
        else if (data?.data) productArray = data.data;
        else if (data?.results) productArray = data.results;

        const mapped = productArray
          .filter(p => {
            const img1 = p.images?.[0] || p.image || p.productImage;
            return isValidImageUrl(img1);
          })
          .slice(0, 2)
          .map((p, arrayIndex) => {
            const img1 = p.images?.[0] || p.image || p.productImage;
            const img2 = (p.images && p.images.length > 1)
              ? p.images[1]
              : (p.image2 || img1);

            const normalizedImg1 = isValidImageUrl(img1) ? normalizeImageUrl(img1) : DEFAULT_IMAGE;
            const normalizedImg2 = isValidImageUrl(img2) ? normalizeImageUrl(img2) : normalizedImg1;

            // ✅ FIX: 2nd product (index 1) ke liye img aur modelImg swap karo
            // Slide 1 (index 0): img = product image (left), modelImg = model image (right)
            // Slide 2 (index 1): img = model image swap → product left, model right
            const isSecondSlide = arrayIndex === 1;

            return {
              id: p.id || p._id,
              img: isSecondSlide ? normalizedImg1 : normalizedImg1,       // Left: product image
              title: p.name || p.productName || "Product",
              price: p.price || 0,
              priceValue: p.price || 0,
              modelImg: isSecondSlide ? normalizedImg2 : normalizedImg2,  // Right: model image
              subtitle: p.short_description || p.description || "Great product!"
            };
          });

        // ✅ ACTUAL FIX: 2nd slide ke liye images explicitly swap karo
        if (mapped.length >= 2) {
          // Index 1 wale product mein img (left) = images[1] (model), modelImg (right) = images[0] (product)
          // Isliye swap: left pe product chahiye, right pe model
          const secondProduct = mapped[1];
          const originalImg = mapped[1].img;
          const originalModelImg = mapped[1].modelImg;
          // Agar API mein 2nd product ka images[0] model hai aur images[1] product hai
          // toh swap karenge taaki left=product, right=model rahe
          mapped[1] = {
            ...secondProduct,
            img: originalModelImg,      // Left side: jo pehle right tha (product)
            modelImg: originalImg       // Right side: jo pehle left tha (model)
          };

          setProducts(mapped);
        } else {
          setProducts(staticProducts);
        }
      } catch (err) {
        console.error("Failed to fetch seventh section products:", err);
        setProducts(staticProducts);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading && products.length === 0) {
    return null;
  }

  const displayProducts = products.length > 0 ? products : staticProducts;

  const handlePrev = () => {
    if (index > 0) setIndex(prev => prev - 1);
  };

  const handleNext = () => {
    if (index < displayProducts.length - 1) setIndex(prev => prev + 1);
  };

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const currentProduct = displayProducts[index];

  return (
    <section className="seventh-wrapper-seven">
      {/* LEFT SIDE – Product Image */}
      <div
        className="seventh-left-seven"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {isHovered && index > 0 && (
          <button className="arrow-btn-six arrow-left-six" onClick={handlePrev}>
            <FaChevronLeft />
          </button>
        )}

        {isHovered && index < displayProducts.length - 1 && (
          <button className="arrow-btn-six arrow-right-six" onClick={handleNext}>
            <FaChevronRight />
          </button>
        )}

        <img
          src={currentProduct.img}
          alt={currentProduct.title}
          className="seventh-product-img-seven"
          onClick={() => handleProductClick(currentProduct.id)}
          style={{ cursor: "pointer" }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = DEFAULT_IMAGE;
          }}
        />

        <h4 className="seventh-title-seven">{currentProduct.title}</h4>
        <p className="seventh-price-seven">{formatPrice(currentProduct.price)}</p>

        <div className="seventh-dots-seven">
          {displayProducts.map((_, i) => (
            <span
              key={i}
              className={`dot-seven ${i === index ? "active-seven" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>

      {/* RIGHT SIDE – Model Image */}
      <div className="seventh-right-seven">
        <img
          src={currentProduct.modelImg}
          alt="Model"
          className="seventh-model-img-seven"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = DEFAULT_IMAGE;
          }}
        />
        <h2 className="seventh-text-seven">{currentProduct.title}</h2>
      </div>
    </section>
  );
};

export default HomeSeventhSection;